import React from "react";

export const Crypto4hourIcon = ( props: React.SVGProps<SVGSVGElement> ) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
    >
        <g clipPath="url(#clip0_17454_52591)">
            <path
                d="M8.00016 14.6654C11.1298 14.6654 13.6668 12.1283 13.6668 8.9987C13.6668 5.8691 11.1298 3.33203 8.00016 3.33203C4.87056 3.33203 2.3335 5.8691 2.3335 8.9987C2.3335 12.1283 4.87056 14.6654 8.00016 14.6654Z"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M6 1.33203H10"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 6.33203V8.9987"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.6667 9H8"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 1.33203V2.66536"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_17454_52591">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
